import styled from "styled-components";

export const LabelWithMargin = styled("div")`
  color: #000;
  font-weight: 500;
  margin: 7px 5px 0 5px;
`;
